<template>
    <div class="floors-list" :class="[`scroll-${scroll}`]">
        <transition appear>
            <div ref="floorsScroll" class="floors-scroll" :class="[`scroll-${scroll}`]">
                <template v-if="loading">
                    <loading-data></loading-data>
                </template>
                <template v-else-if="floorsList && floorsList.length">
                    <transition-group appear>
                        <div v-for="(floor, floorIndex) in floorsList" :key="floorIndex"
                             class="floor"
                             :class="[`floor-${diffClass(floor,floorIndex)}`]"
                        >
                            <div class="floor-title-vertical">{{floor.title}}</div>
                            <floor-box
																:floor="floor"
																:show-title="false"
																:show-thumbnail="true"
																@floor-clicked="$emit('floor-clicked', floor, floorIndex)"
														></floor-box>
                        </div>
                    </transition-group>
                </template>
                <p style="margin: auto; padding: 1rem;" v-else>{{$t('לא נמצאו נתונים')}}</p>
            </div>
        </transition>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import LoadingData from "@/components/LoadingData";
import FloorBox from "@/components/FloorBox.vue";

export default {
    name: "FloorsList",
    components: {FloorBox, LoadingData},
    props: {
        floors: [Array,Object],
        loading: {
            default: false,
            type: Boolean
        },
				currentApt: {
						default: null
				},
				scroll: {
						default: 'horizontal',
						type: String
				}
    },
    computed:{
        floorsList(){
            if(this.floors){
								if(Array.isArray(this.floors)){
										return this.floors
												.map(apt => Object.assign({}, apt))
												.sort((a,b) => (a.floor > b.floor ? 1 : -1))
								}
								return Object.keys(this.floors)
										.map(k => Object.assign({}, this.floors[k]))
										.sort((a,b) => (a.floor > b.floor ? 1 : -1))
            }
            return null
        },
        separate_titles(){
            if(this.filterOptions && this.filterOptions.separate_titles){
                return this.$store.getters.settings.floors_filter.options.separate_titles
            }
            return null
        },
        ...mapState(['currentProjectId', 'products']),
        ...mapGetters(['isDesktop', 'filterOptions','isSideMenu','apartmentThumbnailDisplay'])
    },
    methods: {
        diffClass(apt, aptIndex){
            return this.floorsList[aptIndex - 1] && this.floorsList[aptIndex - 1].floor === apt.floor ? 'same':'diff'
        },
        handleWheelAndDrag(){
            if(this.isDesktop && this.scroll === 'horizontal'){
                const transformScroll = (event) => {
                    if (!event.deltaY) {
                        return;
                    }

                    event.currentTarget.scrollLeft += event.deltaY + event.deltaX;
                    event.preventDefault();
                }

                const floorsScroll = this.$refs.floorsScroll

                if(floorsScroll){
                    floorsScroll.style.cursor = 'grab'

                    floorsScroll.addEventListener('wheel', transformScroll);

                    let isDown = false;
                    let startX;
                    let scrollLeft;

                    floorsScroll.addEventListener('mousedown', (e) => {
                        isDown = true;
                        floorsScroll.classList.add('active');
                        startX = e.pageX - floorsScroll.offsetLeft;
                        scrollLeft = floorsScroll.scrollLeft;
                        floorsScroll.style.cursor = 'grabbing'
                    });
                    floorsScroll.addEventListener('mouseleave', () => {
                        isDown = false;
                        floorsScroll.classList.remove('active');
                        floorsScroll.style.cursor = 'grab'
                    });
                    floorsScroll.addEventListener('mouseup', () => {
                        isDown = false;
                        floorsScroll.classList.remove('active');
                        floorsScroll.style.cursor = 'grab'
                    });
                    floorsScroll.addEventListener('mousemove', (e) => {
                        if(!isDown) return;
                        e.preventDefault();
                        const x = e.pageX - floorsScroll.offsetLeft;
                        const walk = (x - startX) * 3; //scroll-fast
                        floorsScroll.scrollLeft = scrollLeft - walk;
                    });
                }
            }
        }
    },
    mounted() {
        this.handleWheelAndDrag()
    }

}
</script>

<style scoped lang="scss">

    .floors-list {
        background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 87.46%, #000000 93.93%);
        border-top: solid 3px var(--primary);
        border-bottom: solid 1px #fff;
        padding: 2rem 0 0.9375rem 0;
        position: relative;

        .floors-scroll {
            overflow-x: hidden;
            overflow-y: auto;
            display: block;

            &.v-enter-active,
            &.v-leave-active {
                transition: transform 1s ease;
            }

            &.v-enter-from,
            &.v-leave-to {
                transform: translateY(500px);
            }

            /* scrollbar design for Chrome, Safari and Opera */
            &::-webkit-scrollbar {
                width: 8px;
                height: 8px;
                background-color: #aaa;
            }

            &::-webkit-scrollbar-thumb {
                background: var(--primary);
                height: 8px;
            }

            /* scrollbar design for Edge and Firefox */
            & {
                scrollbar-width: thin;
                scrollbar-color: var(--primary) #aaa;
            }
        }

				&.scroll-horizontal {

						.floors-scroll {
								display: flex;
								overflow-x: auto;
								overflow-y: hidden;
								flex-flow: row nowrap;
						}
				}

				&.scroll-vertical {
						overflow-y: hidden;
						padding: 0;
						flex-grow: 1;

						.floors-scroll {
								height: 100%;
								padding: 0 1rem 1rem;
						}
				}

        .floor {
            display: flex;
            flex-flow: row nowrap;
            flex-shrink: 0;
            overflow: hidden;

            &.v-enter-active,
            &.v-leave-active {
                transition: transform 1s ease;
            }

            &.v-enter-from,
            &.v-leave-to {
                transform: translateY(500px);
            }
        }

        .floor-title-vertical {
            transform: rotate(-90deg) translate(-100%, 1rem);
            transform-origin: top left;
            font-size: 1.875rem;
            color: #686868;

            &::after {
                content: "";
                width: 145px;
                height: 1px;
                background-color: #686868;
                position: absolute;
                right: 0;
                top: 2.5rem;
            }
        }

				.scroll-vertical {

						.floor {
								flex-flow: column;
								align-items: flex-start;

								&.floor-same {
										margin: 15px 0;
								}
						}

						.floor-title-vertical {
								transform: none;
								transform-origin: initial;
								margin-bottom: 20px;
								margin-top: 25px;
								position: relative;
						}
				}

        .floor.floor-same {
            margin-right: 15px;
        }

        .floor.floor-same .floor-title-vertical{
            display: none;
        }

    }

    .is-mobile {
        .floors-list {
            margin-top: 0;
            display: flex;
            flex-flow: column-reverse;
            border-top: none;
            position: relative;
            background-color: #000;
            padding-bottom: 6rem;

            &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 20px;
                right: 20px;
                height: 1px;
                background-color: #fff;
            }

            .floors-scroll,
            .floor {
                flex-flow: column;
                align-items: flex-start;
            }

            .floors-scroll {
                padding: 20px;
            }

            .floor {
                &.floor-same {
                    margin: 15px 0;
                }
            }

            .floor-title-vertical {
                transform: none;
                transform-origin: initial;
                margin-bottom: 20px;
                margin-top: 25px;
                position: relative;

                &::after {
                    top: 100%;
                    margin-top: 5px;
                }
            }

            .floor:first-child .floor-title-vertical {
                margin-top: 0;
            }
        }
    }

		.fp-side-menu-wrapper + .fp-app-wrapper {
				.floors-list {
						margin-top: 0;
				}
		}

</style>
